import ApiGroupCardTitle from './ApiGroupCardTitle.container';

export default ApiGroupCardTitle;
